import React, { useLayoutEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withLastLocation } from 'react-router-last-location';
import _ from 'lodash';
import PropTypes from 'prop-types';

const ScrollToTop = ({ from, avoid, lastLocation }) => {
  useLayoutEffect(() => {
    let needsScroll = true;

    if (from?.length) {
      needsScroll = !!_.find(from, loc => lastLocation?.pathname?.includes(loc));
    }

    if (avoid?.length) {
      const shouldAvoid = _.find(avoid, loc => lastLocation?.pathname?.includes(loc));
      if (shouldAvoid) needsScroll = false;
    }

    const scrolledTo = document.querySelector('.scrolled-to');

    if (needsScroll && !scrolledTo) {
      requestAnimationFrame(() => {
        window.scrollTo(0, 0);
      });
    }
  }, []); // Run once on mount

  return null;
};

ScrollToTop.propTypes = {
  from: PropTypes.array,
  avoid: PropTypes.array,
  lastLocation: PropTypes.object
};

export default withLastLocation(withRouter(ScrollToTop));
